import { FunctionComponent } from 'react';

interface SkeletonProps {
  height?: string;
}

// Universal skeleton component with light gray background
export const Skeleton: FunctionComponent<SkeletonProps> = ({
  height = 'h-screen',
}) => {
  return <div className={`w-full bg-white ${height}`}></div>;
};
